const elemNews = document.querySelectorAll('.wt-News');
window.fireOnVisible(elemNews, async () => {
    await import('./assets/css/wt-News.scss');
});
